import type { JSX } from "react";
import type { ChildrenProp } from "@charterindex/armoury-www";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./theme";
import { globalStyles } from "./global-styles";


export const Theme = ({ children }: ChildrenProp): JSX.Element => (
	<ThemeProvider theme={ theme }>
		<CssBaseline/>
		{ globalStyles }
		{ children }
	</ThemeProvider>
);